import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import windowSize from 'react-window-size'
import axios from 'axios'
import Favicon from 'react-favicon'
import DocumentTitle from 'react-document-title'

import { getURL } from '../../utils/io'
import Loading from '../Shared/Loading'
import Renderer from '../Renderer'
import Frame from './Frame'
import { WEB, DEFAULT_SIZE } from './SizeMenu'
import AppDetails from './AppDetails'
import Attribution from './Attribution'
import Stripe from './Stripe'
import Spacer from './Spacer'
import NotFound from './NotFound'
import './Share.css'
import './WrappedSelect.css'

class Preview extends Component {
  state = {
    size: null,
    app: null,
  }

  requestApp = async () => {
    let { match } = this.props
    let { appId } = match.params

    let url

    if (appId) {
      url = getURL(appId)
    } else {
      let host = window.location.host.split(':')[0]
      let query = `host=${encodeURIComponent(host)}`
      url = `${getURL('search')}?${query}`
    }

    try {
      let response = await axios.get(url)
      this.setState({ app: response.data })
    } catch (error) {
      this.setState({ error: true })
      console.error(`ERROR: ${error}`)
    }
  }

  componentDidMount() {
    this.requestApp()
  }

  render() {
    let { match, windowWidth } = this.props
    let { app, size, error } = this.state

    if (error) {
      return <NotFound />
    }

    if (!app) {
      return <Loading expanded />
    }

    let appId = app.id

    let { primaryPlatform, showBranding } = app

    // show branding should be enabled if it is undefined
    if (typeof showBranding === 'undefined') showBranding = true

    // let includeWeb = false

    if (primaryPlatform === 'web') {
      // includeWeb = true
      size = size || WEB
    }

    if (size === WEB) {
      return (
        <div>
          <Favicon url={`${getURL(appId)}/icon?size=32&radius=7`} />
          <div className="web-preview-header">
            <Stripe className="top-stripe" branding={app.branding} />
            <div className="web-preview-header-logo" />
            <Spacer />
            {/* NOTE: Commenting out until we have a chance to revisit.
            <SizeMenu
              inline
              includeWeb
              size={size}
              onChange={this.handleChangeSize}
              defaultSize={WEB}
            />
            */}
          </div>
          <div className="web-renderer-wrapper">
            <Renderer match={match} offsetTop={64} />
          </div>
        </div>
      )
    }

    if (windowWidth < 890) {
      return <Renderer analytics match={match} />
    }

    size = size || DEFAULT_SIZE

    return (
      <React.Fragment>
        <DocumentTitle title={app.name} />
        <Favicon url={`${getURL(appId)}/icon?size=32&radius=7`} />
        <Stripe branding={app.branding} className="top-stripe" />
        <div className="preview">
          <AppDetails app={app} />
          <Frame appId={appId} size={size} />
        </div>
        {showBranding && <Attribution />}
      </React.Fragment>
    )
  }
}

export default withRouter(windowSize(Preview))
